import dayjs from 'dayjs';
import { observable, action, makeObservable } from 'mobx';
import i18n from 'i18next';
import { useApi} from '/@/app/Api';


class TipState {
    api=null;
    tip = null;
    lang=null;
    modalOpened = false;
    loading = false;
    date = null;

    constructor() {
        this.initiated = false;
        this.date = null;
        makeObservable(this, {
            tip: observable,
            date: observable,
            modalOpened: observable,
            setTip: action,
            setDate: action,
            modalShow: action,
            modalClose: action,
            setLoading: action,
        });
    }

    //
    // Init should be started manually.
    //
    init() {
        if (this.initiated) {
            return;
        }
        this.initiated = true;
        // FIXME decouple TipState from UserFlowState
        setInterval(() => {
            this.fetchTip();
        }, 60 * 1000);  // Check the date every minute
        this.fetchTip();
    }

    setTip(tip) {
        this.tip = tip;
    }
    setDate(date) {
        this.date = date;
    }
    modalShow() {
        this.modalOpened = true;
    }
    modalClose() {
        this.modalOpened = false;
    }
    setLoading(loading) {
        this.loading = loading;
    }

    fetchTip() {
        if (this.loading) {
            return;
        }
        const newDate = dayjs();
        if (this.date === null
            || newDate.format('YYYY-MM-DD') !== this.date.format('YYYY-MM-DD')
            || i18n.language!=this.lang
	) {
	    this.lang=i18n.language;
            this.setLoading(true);
            const dFormatted = newDate.format('YYYY-MM-DD');
            this.api.request(
                `cabinet/tip-of-the-day/${dFormatted}`,
		{},
                {api_url:'v2',auth_navigate:false},
                // Ignore if ToD fails, as it's a secondary feature.
                // The component will just be hidden, and it'll retry later.
                "__all__",
            ).then((data) => {
                this.setTip(data);
                this.setDate(newDate);
            });
            this.setLoading(false);
        }
    };

}

// Keep global, to prevent double-fetch on double renders.
export const tipState = new TipState();

export function injectApi(api)
{
	tipState.api = api;
}
